'use strict';

export { default } from './customComponent.factory';